export const signOut = () => (dispatch) => {
  localStorage.removeItem('lzr_orgId')
  localStorage.removeItem('lzr_authKey')
  localStorage.removeItem('lzr_auth_expiry')
  dispatch({type: 'CLEAR_STORE'})
}
